export default "__VITE_ASSET__316815be__"